import React, { FC } from 'react';
import { FCOType } from '../../../core/types/fcoTypes';
import { useTectonTheme, Tooltip } from '@tecton/ComponentRedesign';
import styled from '@emotion/styled';
import Icon, { IconTypes } from './Icons/Icon';

interface TectonFCOProps {
  type: FCOType;
  name: string;
  description?: string;
}

const TectonFCO: FC<TectonFCOProps> = ({ type, name, description }) => {
  const { theme } = useTectonTheme();

  let icon = <></>;

  const FCOContainer = styled.div`
    display: inline-flex;
    gap: 8px;
    padding: ${theme.padding.s} ${theme.padding.l};
    cursor: pointer;
    align-items: center;
  `;

  const IconContainer = styled.div`
    vertical-align: middle;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `;

  const FCOName = styled.div`
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
  switch (type) {
    case FCOType.DATASET:
      icon = Icon[IconTypes.DATASET];
      break;
    case FCOType.DATA_SOURCE:
      icon = Icon[IconTypes.SOURCES];
      break;
    case FCOType.ENTITY:
      icon = Icon[IconTypes.ENTITIES];
      break;
    case FCOType.FEATURE_SERVICE:
      icon = Icon[IconTypes.FEATURE_SERVICE];
      break;
    case FCOType.FEATURE_VIEW:
      icon = Icon[IconTypes.FEATURE_VIEWS];
      break;
    case FCOType.TRANSFORMATION:
      icon = Icon[IconTypes.TRANSFORMATIONS];
  }

  return (
    <>
      <Tooltip
        title={name}
        content={description || 'No description provided.'}
        data-testid="fco-display"
        trigger={
          <FCOContainer>
            <IconContainer>{icon}</IconContainer>
            <FCOName>{name}</FCOName>
          </FCOContainer>
        }
      />
    </>
  );
};

export default TectonFCO;
